import styled from '@emotion/styled';
import { FormError } from 'ui/components/elements/FormError/FormError';
import AttentionIcon from 'ui/images/attention.svg';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    max-height: 80vh;
    padding: 40px;
`;

const Descriptions = styled.div`
    display: flex;
    gap: 5px;
    align-items: center;
    justify-content: center;
    padding-bottom: 5px;

    img {
        width: 20px;
        height: 20px;
    }
`;

const Desc = styled.p`
    white-space: pre-line;
    font-weight: var(--font-bold);
`;

const TextArea = styled.textarea`
    width: 100%;
    height: 100px;
    padding: 8px;
    border: 2px solid #a9a9a9;
    border-radius: 4px;
    font-size: var(--font-normal);
`;

const SubmitButton = styled.button`
    width: 80%;
    max-width: 200px;
    background-color: var(--warn);
    color: var(--white);
    font-size: var(--font-large);
    font-weight: var(--font-bold);
    padding: 15px;
    border-radius: 25px;
    cursor: pointer;
    margin: 10px auto 0 auto;
    border: none;
    outline: none;
`;

const ErrorMsgContainer = styled.div`
    margin-right: auto;
`;

const Attention = styled.div`
    font-size: var(--font-default);
    color: red;
    margin-top: 5px;
    line-height: 1.5;
`;

interface Props {
    agentName: string;
    setValue: (value: string) => void;
    onClick: () => void;
    errorMsg: string;
    loading: boolean;
}

/**
 * 仲介業者をブロックするのモーダル
 */
export const ArchiveAgentModal: React.FC<Props> = ({ agentName, setValue, onClick, errorMsg, loading }) => {
    return (
        <Wrapper>
            <Descriptions>
                <img src={AttentionIcon} alt="警告アイコン" />
                <Desc>{agentName}様を通報します。</Desc>
            </Descriptions>
            <TextArea
                maxLength={1000}
                placeholder="通報理由をご記入お願いします。"
                onChange={(e) => setValue(e.target.value)}
            />
            <ErrorMsgContainer>{errorMsg && <FormError message={errorMsg} />}</ErrorMsgContainer>

            <Attention>
                ※通報するとお相手からメッセージを受け取ることができなくなります。
                <br />
                ※通報理由はお相手の画面にも表示されます。
            </Attention>

            <SubmitButton disabled={loading} onClick={onClick}>
                通報する
            </SubmitButton>
        </Wrapper>
    );
};
